import React from 'react'

import { useCalculatorForm } from '../../hooks/useCalculatorForm'
import { CalculatorCityAutocomplete } from './CalculatorCityAutocomplete'
import { CalculatorDateFields } from './CalculatorDateFields'
import { CalculatorStateField } from './CalculatorStateField'

type CalculatorLocationFieldsProps = {
  calculatorForm: ReturnType<typeof useCalculatorForm>
}

export const CalculatorLocationFields: React.FC<CalculatorLocationFieldsProps> = ({ calculatorForm }) => {
  const {
    fieldValues,
    validMonths,
    validYears,
    validDays,
    locations,
    filteredLocations,
    locationsLoading,
    locationsError,
    validationErrors,
    isDateValid,
    updateMonth,
    updateDay,
    updateYear,
    updateState,
    updateCityQuery,
    selectCity,
  } = calculatorForm

  return (
    <>
      <CalculatorDateFields
        startMonth={fieldValues.startMonth}
        startDay={fieldValues.startDay}
        startYear={fieldValues.startYear}
        validMonths={validMonths}
        validYears={validYears}
        validDays={validDays}
        validationError={validationErrors['start-date']}
        onMonthChange={updateMonth}
        onDayChange={updateDay}
        onYearChange={updateYear}
      />

      <CalculatorStateField state={fieldValues.state} onStateChange={updateState} />

      <CalculatorCityAutocomplete
        cityQuery={fieldValues.cityQuery}
        locations={filteredLocations}
        totalLocationCount={locations.length}
        disabled={!isDateValid}
        loading={locationsLoading}
        isCityValid={calculatorForm.isCityValid}
        helperText={locationsError || undefined}
        validationError={validationErrors.city}
        onCityQueryChange={updateCityQuery}
        onCitySelect={selectCity}
        onCityBlur={calculatorForm.validateCityOnBlur}
      />
    </>
  )
}
